import { IntroScreenUIConfig } from "../components/ui/intro-screen-ui";
import { SingleScenarioInfoConfig } from "../components/ui/scenario-info-ui";
import { GeneralQuestionUIConfig, GeneralQuestionUIConfigOption } from "../cvp-webgames-core/Components/ui/react/core-general-question-ui";
import GameManager from "../cvp-webgames-core/GameManager";
import Tools from "../cvp-webgames-core/Misc/Tools";
import BaseScenarioPart from "../cvp-webgames-core/Scenario/BaseScenarioPart";
import { VideoSegmentItem, SingleVideoSegmentItem } from "../cvp-webgames-core/VideoSegment/VideoSegmentItem";
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from "../cvp-webgames-core/pre-caching/pre-cache-item";
import { constants } from "../misc/constants";
import { CustomGameDataManager, PageType, updateMentorVideo } from "../misc/tools";
import { GameBaseScenario } from "./GameBaseScenario";

class Scenario2VideoSegments extends VideoSegmentItem {
	public get title(): string {
		return 'Inpatient Mental Health Group Setting';
    }

	public videoKey = 'Video';
	public get mentorVidUrl(): string {
		return this.getItems()[1].src;
	}
	public cinematicKeys = {
		chapter1: 'chapter1', //played on step 2
		chapter1Part2: 'chapter1Part2', //played on step 2c
		chapter1Resume: 'chapter1-resume',

		chapter2: 'chapter2', //played on step 5
		chapter2Part2: 'chapter2Part2', //played on step 5c
		chapter2Resume: 'chapter2-resume',

		chapter3: 'chapter3', //played on step 7
		chapter3Part2: 'chapter3Part2', //played on step 7c
		chapter3Part3: 'chapter3Part3', //played on step 7e
		chapter3Part4: 'chapter3Part4', //played on step 7g
		chapter3Resume: 'chapter3-resume',

		chapter4: 'chapter4', //played on step 9
		chapter4Resume: 'chapter4-resume',
		chapter5: 'chapter4-resume', //played on step 12
    };

	public mentorKeys = {
		situation: 'mentor-2', //played on situation screen
		mentor1Correct: 'mentor-1', //played on ____ correct
		mentor1Incorrect: 'mentor-1', //played on ____ incorrect
		review: 'mentor-3', //played on review screen

		BnScn02All001: 'Bn-Scn-02-All-001',
		BnScn02All005: 'Bn-Scn-02-All-005',
		BnScn02All011: 'Bn-Scn-02-All-011',
		BnScn02All014: 'Bn-Scn-02-All-014',
		BnScn02All017: 'Bn-Scn-02-All-017',
		BnScn02All019: 'Bn-Scn-02-All-019',
		BnScn02All021: 'Bn-Scn-02-All-021',
		BnScn02All023: 'Bn-Scn-02-All-023',
		BnScn02All025: 'Bn-Scn-02-All-025',
		BnScn02All027: 'Bn-Scn-02-All-027',
		BnScn02All029: 'Bn-Scn-02-All-029',
		BnScn02All032: 'Bn-Scn-02-All-032',
		BnScn02All037: 'Bn-Scn-02-All-037',
		BnScn02All040: 'Bn-Scn-02-All-040',
		BnScn02All042: 'Bn-Scn-02-All-042',
		BnScn02All044: 'Bn-Scn-02-All-044',
		BnScn02All045: 'Bn-Scn-02-All-045',
		BnScn02All047: 'Bn-Scn-02-All-047',
		BnScn02All049: 'Bn-Scn-02-All-049',
		BnScn02All050: 'Bn-Scn-02-All-050',
		BnScn02All052: 'Bn-Scn-02-All-052',
		BnScn02All054: 'Bn-Scn-02-All-054',
		BnScn02All055: 'Bn-Scn-02-All-055',
		BnScn02All057: 'Bn-Scn-02-All-057',
		BnScn02All062: 'Bn-Scn-02-All-062',
		BnScn02All070: 'Bn-Scn-02-All-070',
		BnScn02All072: 'Bn-Scn-02-All-072',
		BnScn02All074: 'Bn-Scn-02-All-074',
		BnScn02All076: 'Bn-Scn-02-All-076',
		BnScn02All077: 'Bn-Scn-02-All-077',
		BnScn02All078: 'Bn-Scn-02-All-078',
		BnScn02All079: 'Bn-Scn-02-All-079',
		BnScn02All080: 'Bn-Scn-02-All-080',
		BnScn02All082: 'Bn-Scn-02-All-082',
		BnScn02All084: 'Bn-Scn-02-All-084',
		BnScn02All085: 'Bn-Scn-02-All-085',
		BnScn02All087: 'Bn-Scn-02-All-087',
		BnScn02All089: 'Bn-Scn-02-All-089',
		BnScn02All090: 'Bn-Scn-02-All-090',
		BnScn02All092: 'Bn-Scn-02-All-092',
		BnScn02All098: 'Bn-Scn-02-All-098',
		BnScn02All100: 'Bn-Scn-02-All-100',
		BnScn02All101: 'Bn-Scn-02-All-101',
		BnScn02All103: 'Bn-Scn-02-All-103',
		BnScn02All105: 'Bn-Scn-02-All-105',
		BnScn02All106: 'Bn-Scn-02-All-106',
		BnScn02All108: 'Bn-Scn-02-All-108',
		BnScn02All110: 'Bn-Scn-02-All-110',
		BnScn02All111: 'Bn-Scn-02-All-111',
		BnScn02All113: 'Bn-Scn-02-All-113',
		BnScn02All115: 'Bn-Scn-02-All-115',
		BnScn02All116: 'Bn-Scn-02-All-116',
		BnScn02All118: 'Bn-Scn-02-All-118',
		BnScn02All120: 'Bn-Scn-02-All-120',
		BnScn02All122: 'Bn-Scn-02-All-122',
    };
	
	public getItems(): SingleVideoSegmentItem[] {
		return [
			{
				key: this.videoKey,
				src: process.env.PUBLIC_URL + '/assets/videos/scenario-02/video.mp4',
				type: PrecacheItemType.Video
			},
			{
				key: 'Feedback',
				src: process.env.PUBLIC_URL + '/assets/mentor-vids/scn-02/Mentor-Bs-Scn-02-Full.mp4',
				type: PrecacheItemType.Video
			}
		];
	}
}

export const scenario2VideoSegments = new Scenario2VideoSegments();

export default class Scenario2 extends GameBaseScenario {
	public partId = 'scenario';

	public get MentorTalkingVideo(): string {
		return scenario2VideoSegments.mentorVidUrl;
    }
	
	public getScenarioInfo(): SingleScenarioInfoConfig {
		return null;
    }

	public resumeScenarioFromArea(areaIndx: number): void {
		Tools.getSaveData().then((savedData: CustomGameDataManager) => {
			this.hudId = this.uiWrapper.displayHUD({
			});
			//resume on or after the first question
			let onDone: () => void = null;
			let chapterId: string = null;
			switch(areaIndx) {
				case 0:
					chapterId = scenario2VideoSegments.cinematicKeys.chapter1Resume;
					onDone = () => this.step4();
					break;
				case 1:
					chapterId = scenario2VideoSegments.cinematicKeys.chapter2Resume;
					onDone = () => this.step6();
					break;
				case 2:
					chapterId = scenario2VideoSegments.cinematicKeys.chapter3Resume;
					onDone = () => this.step8();
					break;
				case 3:
					chapterId = scenario2VideoSegments.cinematicKeys.chapter4Resume;
					onDone = () => this.step10();
					break;
				case 4:
					chapterId = scenario2VideoSegments.cinematicKeys.chapter4Resume;
					onDone = () => this.step12();
					break;
			}
	
			setTimeout(() => {
				this.playVideoChapter(this.partId, chapterId, () => {
					onDone();
				}, false)
			}, 250);
		});
	}

	public scenarioIndex(): number {
		return 1;
    } 

	public scenarioId(): PageType {
		return PageType.Scenario2;
    }
	private video: SingleVideoSegmentItem = scenario2VideoSegments.getItemByKey(scenario2VideoSegments.videoKey);

	public getScenarioVideoURL(): string {
		return this.video.src;
	}


	public introScreenInfo(): IntroScreenUIConfig {
		return null
	}

	private parts: BaseScenarioPart<GameBaseScenario>[] = [{
		partId: this.partId,
		scenario: this,
		videoUrl: [scenario2VideoSegments.getItemByKey(scenario2VideoSegments.videoKey).src],
		start: () => {
		},
		playVideoChapter: (chapterId: string, onDone: () => void) => {
			(this.playVideoChapter(this.partId, chapterId, onDone, false))
		}
	}]

	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName);
	}

	start() {
		this.step0();
	}

	public getParts(): BaseScenarioPart<GameBaseScenario>[] {
		return this.parts;
	}

	public getSoundPath(fileName: string): string {
		return process.env.PUBLIC_URL + '/assets/audio/scenario1/' + fileName + '.ogg';
	}

	//load video
	step0() {
		// this.loadPart(this.partId, () => {
			this.step1();
		// });
	}

	//1.	Scenario Intro
	step1() {
		updateMentorVideo(true, scenario2VideoSegments.mentorVidUrl, scenario2VideoSegments.mentorKeys.BnScn02All001);
		this.hudId = this.uiWrapper.displayHUD({
		});
		this.uiWrapper.displayIntroScreenUI({
			title: 'Situation',
			buttonText: 'Continue',
			htmlData: `
			<div>
				<p class="black-text">
					You are working on the Inpatient Mental Health Unit at your facility. Veterans receiving care on 
					an inpatient unit may have voluntarily sought care or may be under a legal hold. These units are secured, 
					and Veterans are not discharged from the unit until it is determined that they are no longer an acute risk to 
					themselves or others. You are co-facilitating a group with a colleague. Though you are quite familiar with the 
					group material, your colleague has recently graduated from their clinical program and is new to the field. In this 
					scenario, you will interact with the group and your co-facilitator. One group member is interacting in a way that 
					is disrespectful to your co-facilitator and other group members.
				</p>
			</div>
			`,
			audioUrls: null,
			spaceForMentor: true,
			onStartScenarioClicked: () => {
				this.step2();
			}
		})
	}

	//2.	Cinematic 1 (Video)
	step2() {
		this.playVideoChapter(this.partId, scenario2VideoSegments.cinematicKeys.chapter1, () => {
			this.step2b();
		}, false)
	}

	//2-b.	Time passes
	step2b() {
		//UNCOMMENT FOR MENTOR
		updateMentorVideo(true, scenario2VideoSegments.mentorVidUrl, scenario2VideoSegments.mentorKeys.BnScn02All005);
		this.uiWrapper.displayIntroScreenUI({
			title: 'Information',
			buttonText: 'Continue',
			htmlData: `
			<div>
				<p class="black-text">
					Currently the facilitator is establishing the group rules and expectations and the limits of 
					confidentiality. In this scenario the group starts smoothly, and everyone is engaged. Then Veteran 
					Williams has a question which raises concern. Let's see what Veteran Williams' question is.
				</p>
			</div>
			`,
			onReplayContentClicked: () => {
				this.step2();
			},
			audioUrls: null,
			spaceForMentor: true,
			onStartScenarioClicked: () => {
				this.step2c();
			}
		})
	}

	//2-c.	Cinematic 1-b (Video)
	step2c() {
		this.playVideoChapter(this.partId, scenario2VideoSegments.cinematicKeys.chapter1Part2, () => {
			this.step3();
			this.step4();
		}, false)
	}

	//3.	Display UI
	step3() {
		
	}

	//4.	Question 1
	step4(customOptions?: GeneralQuestionUIConfigOption[]) {
		updateMentorVideo(false, scenario2VideoSegments.mentorVidUrl, scenario2VideoSegments.mentorKeys.BnScn02All011);
		const options = customOptions ?? [{
			title: 'Option 1',
			mentorVid: scenario2VideoSegments.mentorVidUrl,
			mentorOption: [scenario2VideoSegments.mentorKeys.BnScn02All014],
			isCorrect: false,
			description: 'You look at Dr. Jane and she does not respond so you choose to ignore the statement and keep going. If Dr. Jane is uncomfortable, they will say something.',
			feedbackHtml: 'Not the best answer! By choosing not to acknowledge or respond to Veteran Williams\' inappropriate comments, you may send a signal that this behavior is acceptable and could encourage such behavior to continue. As defined by VHA Directive 5019.02 (3. G), "Sexual harassment is any unsolicited verbal or physical contact of a sexual nature which is threatening in character, unwelcome, sexual advances, and request for sexual favors. These comments may include actions such as sexually oriented verbal kidding, teasing, or jokes; repeated sexual flirtations, advances, or proposals; or continued sexual flirtations, advances or propositions" (3.G.1-3). Being clear and forthcoming about boundaries will make it easier moving forward for Veteran Williams to know what to expect regarding treating peers, staff, and all others with respect. According to the ERASE model "Addressing" behaviors in real time is the most effective redirection. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario2VideoSegments.mentorKeys.BnScn02All017]
		}, {
			title: 'Option 2',
			mentorVid: scenario2VideoSegments.mentorVidUrl,
			mentorOption: [scenario2VideoSegments.mentorKeys.BnScn02All019],
			isCorrect: true,
			description: '"Veteran Williams, this group covers skills to learn how to manage strong emotions. Let\'s stay on topic so that everyone can learn the skills we are covering today. Please do not make comments of that nature in this group."',
			feedbackHtml: 'Correct! This is an example of a directly worded response that is appropriate. According to VA Handbook 5979 (5. C) "Employees and contractors that have been subjected to unwelcome conduct are encouraged to inform the person(s) responsible for the conduct that it is unwelcome and offensive. If the conduct continues or the individual is uncomfortable confronting the responsible person(s) regarding the conduct, the individual should report the matter to a VA official (VA Management Official, HPC, ORMDI HPP Office) immediately. You also need to report this behavior in the disruptive behavior reporting system (DBRS) @ <a target="_blank" href="https://cfm.vssc.med.va.gov/dbr/main.cfm">https://cfm.vssc.med.va.gov/dbr/main.cfm</a>.',
			mentorFeedback: [scenario2VideoSegments.mentorKeys.BnScn02All021]
		}, {
			title: 'Option 3',
			isCorrect: false,
			mentorVid: scenario2VideoSegments.mentorVidUrl,
			mentorOption: [scenario2VideoSegments.mentorKeys.BnScn02All027],
			description: '"That is completely inappropriate, and you will need to leave the group because it is disrespectful to ask a clinician out on a date."',
			feedbackHtml: 'Not the best answer! This may be too strong as a preliminary intervention. Threatening to have the Veteran removed may escalate the situation. In situations like this, it may be useful to begin by providing feedback so that the Veteran understands the expectations and group rules. However, if you have safety concerns for yourself or the patient(s), then removing the Veteran may be appropriate. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario2VideoSegments.mentorKeys.BnScn02All029]

		}, {
			title: 'Option 4',
			isCorrect: true,
			description: '"Veteran Williams it is not appropriate to make comments about dating to the staff or members of this group."',
			mentorVid: scenario2VideoSegments.mentorVidUrl,
			mentorOption: [scenario2VideoSegments.mentorKeys.BnScn02All023],
			feedbackHtml: 'Correct! This is an example of the Direct Intervention technique, clearly describing the inappropriate behavior that should stop.',
			mentorFeedback: [scenario2VideoSegments.mentorKeys.BnScn02All025]
		}]
		this.uiWrapper.displayQuestonType1UI({
			title: PageType.Scenario2,
			subtitle: ('Question 1'),
			audioUrl: null,
			options:options,
			multipleChoice: false,
			questionTitle: 'Select the response that best aligns with your action. There may be more than one appropriate response.',
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario2VideoSegments.getItemByKey('Feedback');
				this.onQuestionType1Submitted(allOptions, selectedChoices, parentQuestionConfig,
												 () => { //Next Step (if correct)
													this.step5();
												 }, (optionsToShow: GeneralQuestionUIConfigOption[]) => { //Next Step (if incorrect)
													this.step4(optionsToShow);
												 }, mentorInfo.src);
			}
		}, 0, 1, () => this.step2())
	}

	//5.	Cinematic 2 (Video)
	step5() {
		this.playVideoChapter(this.partId, scenario2VideoSegments.cinematicKeys.chapter2, () => {
			this.step5b();
		}, false)
	}

	//5-b.	Time passes
	step5b() {
		//UNCOMMENT FOR MENTOR
		updateMentorVideo(true, scenario2VideoSegments.mentorVidUrl, scenario2VideoSegments.mentorKeys.BnScn02All032);
		this.uiWrapper.displayIntroScreenUI({
			title: 'Information',
			buttonText: 'Continue',
			htmlData: `
			<div>
				<p class="black-text">
					You continue with the group and other group members appear to be interacting with each 
					other appropriately. The team continues conversating as time passes.
				</p>
			</div>
			`,
			onReplayContentClicked: () => {
				this.step5();
			},
			audioUrls: null,
			spaceForMentor: true,
			onStartScenarioClicked: () => {
				this.step5c();
			}
		})
	}

	//2-c.	Cinematic 2-b (Video)
	step5c() {
		this.playVideoChapter(this.partId, scenario2VideoSegments.cinematicKeys.chapter2Part2, () => {
			this.step6();
		}, false)
	}

	//6.	Question 2
	step6(customOptions?: GeneralQuestionUIConfigOption[]) {
		updateMentorVideo(false, scenario2VideoSegments.mentorVidUrl, scenario2VideoSegments.mentorKeys.BnScn02All037);
		const options = customOptions ?? [{
			title: 'Option 1',
			isCorrect: false,
			description: 'You ignore the statement and decide to call on another Veteran in the group to see if they have a response.',
			mentorVid: scenario2VideoSegments.mentorVidUrl,
			mentorOption: [scenario2VideoSegments.mentorKeys.BnScn02All040],
			feedbackHtml: 'Not the best answer! Not addressing the inappropriate behavior can encourage the behavior to continue. It is important to send a clear message about the behavioral expectations when Veterans are not respectful to others in treatment settings. This is not a clinical response to the behavior. ',
			mentorFeedback: [scenario2VideoSegments.mentorKeys.BnScn02All042]
		}, {
			title: 'Option 2',
			isCorrect: false,
			description: 'You deflect by asking Veteran Williams “When is your next group session?”',
			mentorVid: scenario2VideoSegments.mentorVidUrl,
			mentorOption: [scenario2VideoSegments.mentorKeys.BnScn02All044, scenario2VideoSegments.mentorKeys.BnScn02All045],
			feedbackHtml: 'This is not a clinical response to the behavior. This response does not describe the inappropriate behaviors or explain that they need to stop. It is important to clearly communicate to the Veteran what the behavioral expectations are. Keep in mind that you may later decide to escalate the matter as warranted if the Veteran does not comply to these initial steps.',
			mentorFeedback: [scenario2VideoSegments.mentorKeys.BnScn02All047]

		}, {
			title: 'Option 3',
			mentorVid: scenario2VideoSegments.mentorVidUrl,
			mentorOption: [scenario2VideoSegments.mentorKeys.BnScn02All049, scenario2VideoSegments.mentorKeys.BnScn02All050],
			isCorrect: true,
			description: 'You say to Veteran Williams: "One of the rules here is everyone should be treated with respect. Your comments are inappropriate, and they need to stop so that we can continue with group."',
			feedbackHtml: 'Correct! This response provides a "Direct" intervention as part of the ERASE model, directs the Veteran to stop the behavior, and links the desired or corrected behavior (the behavior stops) with an objective outcome (the group continues). You should discuss the incident with the treatment team to make them aware of the inappropriate behavior.',
			mentorFeedback: [scenario2VideoSegments.mentorKeys.BnScn02All052]
		}, {
			title: 'Option 4',
			isCorrect: true,
			description: 'You say: "We would like for you to be able to remain in the group and I would like you to stop making inappropriate comments."',
			mentorVid: scenario2VideoSegments.mentorVidUrl,
			mentorOption: [scenario2VideoSegments.mentorKeys.BnScn02All054, scenario2VideoSegments.mentorKeys.BnScn02All055],
			feedbackHtml: 'Correct! This response is brief, clear, and makes a specific request. You should discuss the incident with the treatment team to make them aware of the inappropriate behavior.',
			mentorFeedback: [scenario2VideoSegments.mentorKeys.BnScn02All057]
		}]
		this.uiWrapper.displayQuestonType1UI({
			title: PageType.Scenario2,
			subtitle: ('Question 2'),
			audioUrl: null,
			options:options,
			multipleChoice: false,
			questionTitle: 'Select the response that best aligns with your action. There may be more than one appropriate response.',
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario2VideoSegments.getItemByKey('Feedback');
				this.onQuestionType1Submitted(allOptions, selectedChoices, parentQuestionConfig,
												 () => { //Next Step (if correct)
													this.step7();
												 }, (optionsToShow: GeneralQuestionUIConfigOption[]) => { //Next Step (if incorrect)
													this.step6(optionsToShow);
												 }, mentorInfo.src);
			}
		}, 1, 2, () => this.step5())
	}

	//7.	Cinematic 3 (Video)
	step7() {
		this.playVideoChapter(this.partId, scenario2VideoSegments.cinematicKeys.chapter3, () => {
			this.step7b();
		}, false)
	}

	//7-b.	Time passes
	step7b() {
		//UNCOMMENT FOR MENTOR
		updateMentorVideo(true, scenario2VideoSegments.mentorVidUrl, scenario2VideoSegments.mentorKeys.BnScn02All122);
		this.uiWrapper.displayIntroScreenUI({
			title: 'Information',
			buttonText: 'Continue',
			htmlData: `
			<div>
				<p class="black-text">
					Time passes...
				</p>
			</div>
			`,
			onReplayContentClicked: () => {
				this.step7();
			},
			audioUrls: null,
			spaceForMentor: true,
			onStartScenarioClicked: () => {
				this.step7c();
			}
		})
	}

	//7-c.	Cinematic 3-b (Video)
	step7c() {
		this.playVideoChapter(this.partId, scenario2VideoSegments.cinematicKeys.chapter3Part2, () => {
			this.step7d();
		}, false)
	}

	//7-d.	Time passes
	step7d() {
		//UNCOMMENT FOR MENTOR
		updateMentorVideo(true, scenario2VideoSegments.mentorVidUrl, scenario2VideoSegments.mentorKeys.BnScn02All062);
		this.uiWrapper.displayIntroScreenUI({
			title: 'Information',
			buttonText: 'Continue',
			htmlData: `
			<div>
				<p class="black-text">
					The next day you and Dr. Jane talk outside the hall before joining all the group members who are 
					already waiting inside the group room.
				</p>
			</div>
			`,//check time codes to smooth out the ending TODO
			audioUrls: null,
			spaceForMentor: true,
			onStartScenarioClicked: () => {
				this.step7e();
			},
			onReplayContentClicked: () => {
				this.step7c();
			}
		})
	}

	//7-e.	Cinematic 3-c (Video)
	step7e() {
		this.playVideoChapter(this.partId, scenario2VideoSegments.cinematicKeys.chapter3Part3, () => {
			this.step7f();
		}, false)
	}

	//7-f.	Time passes
	step7f() {
		//UNCOMMENT FOR MENTOR
		updateMentorVideo(true, scenario2VideoSegments.mentorVidUrl, scenario2VideoSegments.mentorKeys.BnScn02All122);
		this.uiWrapper.displayIntroScreenUI({
			title: 'Information',
			buttonText: 'Continue',
			htmlData: `
			<div>
				<p class="black-text">
					Time passes...
				</p>
			</div>
			`,
			audioUrls: null,
			spaceForMentor: true,
			onStartScenarioClicked: () => {
				this.step7g();
			},
			onReplayContentClicked: () => {
				this.step7e();
			}
		})
	}

	//7-g.	Cinematic 3-d (Video)
	step7g() {
		this.playVideoChapter(this.partId, scenario2VideoSegments.cinematicKeys.chapter3Part4, () => {
			this.step8();
		}, false)
	}

	//8.	Question 3
	step8(customOptions?: GeneralQuestionUIConfigOption[]) {
		updateMentorVideo(false, scenario2VideoSegments.mentorVidUrl, scenario2VideoSegments.mentorKeys.BnScn02All070);
		const options = customOptions ?? [{
			title: 'Option 1',
			mentorVid: scenario2VideoSegments.mentorVidUrl,
			mentorOption: [scenario2VideoSegments.mentorKeys.BnScn02All072],
			isCorrect: false,
			description: 'You ignore Veteran Williams and say or do nothing.',
			feedbackHtml: 'Not the best answer! It is important for bystanders to take some action in order to send a clear message that certain behaviors are unacceptable. If inappropriate behavior is not addressed, it may encourage continuation.',
			mentorFeedback: [scenario2VideoSegments.mentorKeys.BnScn02All074]
		}, {
			title: 'Option 2',
			mentorVid: scenario2VideoSegments.mentorVidUrl,
			mentorOption: [scenario2VideoSegments.mentorKeys.BnScn02All076, scenario2VideoSegments.mentorKeys.BnScn02All077, scenario2VideoSegments.mentorKeys.BnScn02All078, scenario2VideoSegments.mentorKeys.BnScn02All079, scenario2VideoSegments.mentorKeys.BnScn02All080],
			isCorrect: true,
			description: 'You say: "Veteran Williams, can I speak to you for a moment?" You and Veteran Williams step out of the group therapy room and into the hallway. Then you say: "I heard you made a comment to the Veteran sitting next to you about going out on a date. One of the rules here is everyone should be treated with respect. Your comments are inappropriate and a distraction from the group."',
			feedbackHtml: 'Correct! Following the ERASE model, you addressed the problem in real time using a Direct Intervention technique. You are modeling respectful behavior by asking the Veteran to step outside the group therapy room rather than correcting him in front of the group. You are also describing the behaviors that are inappropriate and the reason why they are inappropriate in clear, nonjudgmental language.',
			mentorFeedback: [scenario2VideoSegments.mentorKeys.BnScn02All082]
		}, {
			title: 'Option 3',
			mentorVid: scenario2VideoSegments.mentorVidUrl,
			mentorOption: [scenario2VideoSegments.mentorKeys.BnScn02All084, scenario2VideoSegments.mentorKeys.BnScn02All085],
			isCorrect: true,
			description: 'You say: "Veteran Williams, would you describe the skills that we learned about yesterday in group?"',//smooth out time code ending TODO
			feedbackHtml: 'Correct! This is an effective use of the Distract technique. While this response does not convey a direct message about the behavior to Veteran Williams, it does provide a distraction and redirects the Veteran\'s focus, which may be a useful response as a bystander in this scenario.',
			mentorFeedback: [scenario2VideoSegments.mentorKeys.BnScn02All087]
		}, {
			title: 'Option 4',
			mentorVid: scenario2VideoSegments.mentorVidUrl,
			mentorOption: [scenario2VideoSegments.mentorKeys.BnScn02All089, scenario2VideoSegments.mentorKeys.BnScn02All090],
			isCorrect: false,
			description: 'You say: "Knock it off! Leave that Veteran alone. If you keep that up, we are going to discharge you immediately."',
			feedbackHtml: 'Not the best answer! This is too strong of a response. Tone and delivery are unprofessional and threatening discharge would not be clinically appropriate. Providing direct feedback at this stage is a better response. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario2VideoSegments.mentorKeys.BnScn02All092]
		}]
		this.uiWrapper.displayQuestonType1UI({
			title: PageType.Scenario2,
			subtitle: ('Question 3'),
			audioUrl: null,
			options:options,
			multipleChoice: false,
			questionTitle: 'Select the response that best aligns with your action. There may be more than one appropriate response.',
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario2VideoSegments.getItemByKey('Feedback');
				this.onQuestionType1Submitted(allOptions, selectedChoices, parentQuestionConfig,
												 () => { //Next Step (if correct)
													this.step9();
												 }, (optionsToShow: GeneralQuestionUIConfigOption[]) => { //Next Step (if incorrect)
													this.step8(optionsToShow);
												 }, mentorInfo.src);
			}
		}, 2, 3, () => this.step7())
	}

	//9.	Cinematic 4 (Video)
	step9() {
		this.playVideoChapter(this.partId, scenario2VideoSegments.cinematicKeys.chapter4, () => {
			this.step10();
		}, false)
	}

	//10.	Question 4
	step10(customOptions?: GeneralQuestionUIConfigOption[]) {
		updateMentorVideo(false, scenario2VideoSegments.mentorVidUrl, scenario2VideoSegments.mentorKeys.BnScn02All098);
		const options = customOptions ?? [{
			title: 'Option 1',
			mentorVid: scenario2VideoSegments.mentorVidUrl,
			mentorOption: [scenario2VideoSegments.mentorKeys.BnScn02All100, scenario2VideoSegments.mentorKeys.BnScn02All101],
			isCorrect: false,
			description: 'You yell across the room: “Veteran Williams! We\'ve talked about this! Please interact with everyone in this program with respect!”',
			feedbackHtml: 'Not the best answer! Yelling at the Veteran will escalate the situation and disrupt the other group members. Yelling at Veterans is also unprofessional. Please select an option that takes all of this into consideration. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario2VideoSegments.mentorKeys.BnScn02All103]
		}, {
			title: 'Option 2',
			mentorVid: scenario2VideoSegments.mentorVidUrl,
			mentorOption: [scenario2VideoSegments.mentorKeys.BnScn02All105, scenario2VideoSegments.mentorKeys.BnScn02All106],
			isCorrect: true,
			description: 'You say: “Excuse me, Veteran Williams. Please come with me so that we can talk individually about how you can use some of the skills we\'ve covered in this group to manage your emotions. Are you willing to come with me so we can talk about this one on one?”',
			feedbackHtml: 'Correct! This clearly communicates a message to the entire group that the Veteran\'s behaviors need to be addressed, and the misbehavior might have affected other group members. Be aware of this behavior and if it is a pattern of behavior, consider the need to report this behavior to the disruptive behavior reporting system (DBRS) @ <a target="_blank" href="https://cfm.vssc.med.va.gov/dbr/main.cfm">https://cfm.vssc.med.va.gov/dbr/main.cfm</a> if clinically deemed necessary.',
			mentorFeedback: [scenario2VideoSegments.mentorKeys.BnScn02All108]
		}, {
			title: 'Option 3',
			mentorVid: scenario2VideoSegments.mentorVidUrl,
			mentorOption: [scenario2VideoSegments.mentorKeys.BnScn02All110, scenario2VideoSegments.mentorKeys.BnScn02All111],
			isCorrect: true,
			description: 'You say: “Veteran Williams, I\'m sorry that you feel like you are being asked to not speak up in group. That was not my intention. The goal was to ensure that your feedback was appropriate and relevant to the topic being discussed. Do you feel comfortable continuing with group today?”',
			feedbackHtml: 'Correct! This addresses the Veteran\'s expressed displeasure while also addressing the need to remain appropriate in the group. Be aware of this behavior and if it is a pattern of behavior, consider the need to report this behavior to the disruptive behavior reporting system (DBRS) @ <a target="_blank" href="https://cfm.vssc.med.va.gov/dbr/main.cfm">https://cfm.vssc.med.va.gov/dbr/main.cfm</a> if clinically deemed necessary.',
			mentorFeedback: [scenario2VideoSegments.mentorKeys.BnScn02All113]
		}, {
			title: 'Option 4',
			mentorVid: scenario2VideoSegments.mentorVidUrl,
			mentorOption: [scenario2VideoSegments.mentorKeys.BnScn02All115, scenario2VideoSegments.mentorKeys.BnScn02All116],
			isCorrect: false,
			description: 'You say: “Veteran Williams this is at least the 3rd time I\'ve had to talk to you about your behavior. Yesterday you made inappropriate comments to Dr. Jane and another Veteran and today you\'re just being disruptive.”',
			feedbackHtml: 'Not the best answer! This response also does not correct the behavior or address the Veterans concerns. It also brings in issues from a group that not all members of this group were present for, thereby violating the Veteran\'s privacy. This is not an effective response to the behavior.',
			mentorFeedback: [scenario2VideoSegments.mentorKeys.BnScn02All118]
		}]
		this.uiWrapper.displayQuestonType1UI({
			title: PageType.Scenario2,
			subtitle: ('Question 4'),
			audioUrl: null,
			options:options,
			multipleChoice: false,
			questionTitle: 'Select the response that best aligns with your action. There may be more than one appropriate response.',
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario2VideoSegments.getItemByKey('Feedback');
				this.onQuestionType1Submitted(allOptions, selectedChoices, parentQuestionConfig,
												 () => { //Next Step (if correct)
													this.step11();
												 }, (optionsToShow: GeneralQuestionUIConfigOption[]) => { //Next Step (if incorrect)
													this.step10(optionsToShow);
												 }, mentorInfo.src);
			}
		}, 3, 4, () => this.step9())
	}

	//11.	to step 12 (video removed. no part 5)
	step11() {
		this.playVideoChapter(this.partId, scenario2VideoSegments.cinematicKeys.chapter5, () => {
			this.step12();
		}, false)
		//this.playVideoChapter(this.partId, scenario2VideoSegments.cinematicKeys.chapter5, () => {
			//this.step12();
		//}, false)
	}

	//12.	Scenario Recap
	step12() {
		updateMentorVideo(false, scenario2VideoSegments.mentorVidUrl, scenario2VideoSegments.mentorKeys.BnScn02All120);
		this.setAreaForCurrentScenario(4, 5).then(() => {
			this.uiWrapper.displayIntroScreenUI({
				title: 'Scenario Completed',
				buttonText: 'Continue',
				htmlData: `
				<div>
					<p class="black-text">
						Let\'s recap what we were able to review and identify from our interactions with Veteran Williams. When 
						Veterans demonstrate disruptive behaviors, there are a few things that are important to remember.
					<br />
					<ol class="list-bullet">
						<li class="black-text">Providing clear and direct messages to the Veteran with regards to what behavior 
						is inappropriate and what you are asking of the Veteran is important.</li>
						<li class="black-text">Intervention must be done timely, meaning at the time the behavior is occurring.</li>
						<li class="black-text">Staff will maintain respectful interactions with Veterans while outlining clear expectations.</li>
						<li class="black-text">Utilize the least restrictive approach to re-engage the Veteran.</li>
						<li class="black-text">For repeated behavior, stepping outside of the group to address may lead to successful re-engagement. 
						What we didn't review is when the Veteran is not able to be redirected and the behaviors continue and/or escalate. In those 
						situations where the behavior is repeated without response to intervention, or behaviors that create harm to themselves or 
						others a disruptive behavior report should be entered. It is important to be able to distinguish clinically, if the Veteran 
						has awareness and is currently competent to understand directions given when addressing behavior on an inpatient mental 
						health unit. Reporting inappropriate behaviors through the Disruptive Behavior Reporting System enables the treatment team 
						to put the appropriate interventions in place to protect the clinician/provider as well as the patient.</li>
					</ol>
					</p>
				</div>
				`,
				audioUrls: null,
				onStartScenarioClicked: () => {
					this.step13();
				}
			})
		})
	}

	//13.	AAR
	step13() {
		Tools.getSaveData().then((savedData: CustomGameDataManager) => {
			savedData.data.scenarios[this.scenarioIndex()].isCompleted = true;
			Tools.saveGame(savedData).then(() => {
				this.uiWrapper.displayAAR(PageType.Scenario3);
			})
		})
	}
}